<div class="alert-body">
    <i class="fal fa-times-circle fa-5x"></i>
    <h4>{{ 'CONFIRM_TYC_MODAL.TITLE' | translate }}</h4>
    <p class="text-gray">{{ 'CONFIRM_TYC_MODAL.FIRST_TEXT' | translate }}</p>
    <p>{{ 'CONFIRM_TYC_MODAL.SECOND_TEXT' | translate }}</p>
</div>
<div *nzModalFooter class="footer-custom-buttons">
    <button nz-button nzType="default" (click)="clickReject()" class="btn-left">{{ 'CONFIRM_TYC_MODAL.BUTTON_REJECT' | translate }}</button>
    <button nz-button nzType="primary" (click)="clickReturn()" class="btn-right">{{ 'CONFIRM_TYC_MODAL.BUTTON_RETURN' | translate }}</button>
</div>